module.exports = __webpack_public_path__ + "img/ornament-left.7d357c8c.png";